import { faTrash } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { useUserInfor } from "../../../../Context/User";
import { FinalizarReservaProdutoController } from "../../../../Controllers/Vendas/Produtos/GestaoReservas/GestaoReservasControllers";

interface IFinalizarReservaProps {
    disableTooltip?: boolean;
    ID_PRODUTO: number;
    ID_RESERVA_USUARIO: number;
    then: () => void;
}

export default function FinalizarReserva(props: IFinalizarReservaProps) {
    const { UserInfor } = useUserInfor();

    const temPermissao =
        UserInfor.FUNCOES.some((f) => f.NM_FUNCAO === "ADM_ENCERRAR_RESERVA") ||
        props.ID_RESERVA_USUARIO === UserInfor.ID_USUARIO;

    function onButtonClick() {
        FinalizarReservaProdutoController(props.ID_PRODUTO).then(props.then);
    }

    if (temPermissao) {
        return (
            <OverlayTrigger
                show={props.disableTooltip || undefined}
                overlay={
                    <Tooltip
                        id={`FINALIZAR_RESERVA_TOOLTIP_${props.ID_PRODUTO}`}
                    >
                        Finalizar Reserva
                    </Tooltip>
                }
            >
                <button
                    type="button"
                    className="btn btn-outline-danger font-weight-bold mr-2"
                    onClick={onButtonClick}
                >
                    <FontAwesomeIcon size="lg" icon={faTrash} /> Finalizar
                </button>
            </OverlayTrigger>
        );
    } else return null;
}
